export default "__VITE_ASSET__BHJBC5Rx__"